
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

const Cookie = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Cookie Policy - Fly Local Boost</title>
        <meta name="description" content="Learn about our Cookie Policy and how Fly Local Boost uses cookies to improve your browsing experience and website functionality." />
        <meta name="keywords" content="cookie policy, cookies, website cookies, tracking cookies" />
        <link rel="canonical" href="https://fly-social.com/cookie" />
      </Helmet>
      <NavBar />
      
      <div className="container mx-auto px-4 pt-24 md:pt-32 pb-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Cookie Policy</h1>
          
          <div className="prose prose-lg">
            <p className="text-gray-600">Last updated: May 15, 2025</p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. What Are Cookies</h2>
            <p>
              Cookies are small text files that are placed on your computer or mobile device when you visit a website. Cookies are widely used to make websites work more efficiently and provide information to the website owners.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Cookies</h2>
            <p>
              We use cookies for the following purposes:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>Essential cookies:</strong> These cookies are necessary for the website to function and cannot be switched off in our systems.</li>
              <li><strong>Performance cookies:</strong> These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.</li>
              <li><strong>Functionality cookies:</strong> These cookies enable the website to provide enhanced functionality and personalization.</li>
              <li><strong>Targeting cookies:</strong> These cookies may be set through our site by our advertising partners to build a profile of your interests and show you relevant advertisements on other sites.</li>
            </ul>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. Types of Cookies We Use</h2>
            <p>
              <strong>Session Cookies:</strong> These cookies are temporary and are deleted from your device when you close your web browser.
            </p>
            <p>
              <strong>Persistent Cookies:</strong> These cookies remain on your device until they expire or you delete them. They help us recognize you as an existing user.
            </p>
            <p>
              <strong>First-Party Cookies:</strong> These cookies are set by our website.
            </p>
            <p>
              <strong>Third-Party Cookies:</strong> These cookies are set by third parties, such as Google Analytics, to collect information about how visitors use our website.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Managing Cookies</h2>
            <p>
              Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience.
            </p>
            
            <div className="my-8">
              <Link to="/" className="text-fly-purple hover:underline">
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Cookie;
